import { useEffect, useState } from 'react'

export const useIsCitizensPayScriptLoaded = () => {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    const loadedSetter = () => setLoaded(true)
    document.addEventListener('CitizensPayScriptLoaded', loadedSetter)
    return () => document.removeEventListener('CitizensPayScriptLoaded', loadedSetter)
  }, [])

  return loaded
}

export default useIsCitizensPayScriptLoaded
